import React from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import AddPersonalDataForm from 'components/AddPersonalDataForm';
import CheckinNavigation from 'components/acommon/CheckinNavigation';
import Page from 'components/acommon/Page';

function AddPersonalDataScreen() {
  const {t} = useTranslation();
  const methods = useForm();

  return (
    <Page showFooterOnlyMobile paddingBottomMobileFooter>
      <CheckinNavigation title={t('add_personal_data_and_sign')} />
      <FormProvider {...methods}>
        <AddPersonalDataForm />
      </FormProvider>
    </Page>
  );
}

export {AddPersonalDataScreen};
